import AuthLayout from "../../layout/authLayout";
import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import { useNavigate } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "src/firebase/firebase";
import { handleToastMessage } from "src/js/handleToastMessage";
import Select from "../../components/select/select";
import { useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import infoIcon from "../../assets/icons/info.png";
import countryList from "react-select-country-list";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import { requestOtp, verifyOtp } from "src/firebase/admin.js";
import OtpInput from "react-otp-input";
import Modal from "../../components/ui/modal";
const accounts = [
  // {
  //   value: "admin",
  //   label: "Admin",
  // },
  // {
  //   value: "processing team",
  //   label: "Processing team",
  // },
  {
    value: "supplier",
    label: "Supplier",
  },
];

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required."),
  lastName: Yup.string().required("Last name is required."),
  email: Yup.string().email().trim().required("Email is required."),
  // addressLine1: Yup.string(),
  // addressLine2: Yup.string(),
  // ussdAddress: Yup.string(),
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password is too short - should be 6 chars minimum."),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
  accountType: Yup.string().required("Account type is required"),
  country: Yup.string().required("Country is required"),
  phoneNumber: Yup.string().trim().required("Phone number is required."),
});
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  // addressLine1: "",
  // addressLine2: "",
  // ussdAddress: "",
  password: "",
  country: "",
  confirmPassword: "",
  accountType: "",
  phoneNumber: "",
};
export const excludedCountries = [
  "af",
  "ba",
  "by",
  "mm",
  "cf",
  "cd",
  "et",
  "hk",
  "ir",
  "iq",
  "lb",
  "ly",
  "ml",
  "ni",
  "kp",
  "ru",
  "so",
  "sd",
  "ss",
  "sy",
  "ua",
  "ve",
  "ye",
  "zw",
];

const Signup = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(["home"]);
  const [showOtp, setShowOtp] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [data, setData] = useState(null);
  const [isShowError, setIsShowError] = useState(false);
  const filteredOptions = useMemo(() => {
    const allCountries = countryList().getData();
    const filteredCountries = allCountries.filter(
      (country) => !excludedCountries.includes(country.value.toLowerCase())
    );
    return filteredCountries;
  }, []);

  const handleSignup = async (values: any) => {
    setData(values);
    setIsLoading(true);
    await requestOtp(values.phoneNumber);
    setIsLoading(false);
    setShowOtp(true);
    // setIsLoading(true);
  };
  const handleOtp = async () => {
    setOtpLoading(true);
    let _isSuccess = await verifyOtp(otp);
    setOtpLoading(false);
    if (_isSuccess) {
      setShowOtp(false);
      setIsLoading(true);
      createUserWithEmailAndPassword(auth, data.email, data.password)
        .then((userCredential) => {
          addUserInFirebase(data);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error.code);
          switch (error.code) {
            case "auth/email-already-in-use":
              handleToastMessage("error", "Email already in use");
              break;
            default:
              break;
          }
          // ..
        });

      // addUserInFirebase(data);
    } else {
      setIsShowError(true);
    }
  };

  const addUserInFirebase = async (values: any) => {
    let _user = values;
    delete _user.password;
    delete _user.confirmPassword;
    _user.id = uuidv4();
    _user.date = new Date();
    _user.isEnable = true;
    _user.accountLimit = 1000;

    // await addDoc(collection(db, "Accounts"), _users);
    await setDoc(doc(db, "Accounts", _user.id), _user);
    setIsLoading(false);
    handleToastMessage("success", "Account created successfully.");
    navigate("/");
  };
  return (
    <>
      <AuthLayout title={t("Create Your Account")}>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSignup}
          validateOnBlur
        >
          {({
            errors,
            touched,
            handleSubmit,
            setFieldTouched,
            setFieldValue,
            handleChange,
            handleBlur,
            values,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="max-h-[50vh] overflow-y-scroll p-2">
                  <div className="flex gap-4 mb-3">
                    <Input
                      label={t("First Name")}
                      containerClass="w-full"
                      placeholder={t("First Name")}
                      name="firstName"
                      error={errors.firstName}
                      touched={touched.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="solid"
                    />
                    <div className="flex gap-1 items-center">
                      <Input
                        label={t("Last Name")}
                        containerClass="w-full"
                        placeholder={t("Last Name")}
                        name="lastName"
                        error={errors.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.lastName}
                        variant="solid"
                      />

                      <Tooltip
                        title="Users must use their real name or else they may have issues verifying their account"
                        placement="top"
                      >
                        <img
                          src={infoIcon}
                          alt="info"
                          className="h-[25px] w-[25px] cursor-pointer"
                        />
                      </Tooltip>
                    </div>
                  </div>
                  <Input
                    label={t("Email ID")}
                    containerClass="w-full"
                    placeholder={t("Email ID")}
                    name="email"
                    className="mb-3"
                    error={errors.email}
                    touched={touched.email}
                    value={values.email}
                    onChange={(e) => {
                      const value = e.target.value || "";
                      setFieldTouched("email", true);
                      setFieldValue("email", value.toLowerCase());
                    }}
                    onBlur={handleBlur}
                    variant="solid"
                  />
                  <label className="mb-2 text-sm font-semibold inline-block">
                    Phone number
                  </label>
                  <br />
                  <IntlTelInput
                    separateDialCode={true}
                    containerClassName={`intl-tel-input w-full py-2 bg-gray-100 `}
                    inputClassName={`w-full  bg-transparent  `}
                    onPhoneNumberChange={(status, phoneNumber, country) => {
                      setFieldTouched("phoneNumber", true);
                      setFieldValue(
                        "phoneNumber",
                        "+" + country.dialCode + phoneNumber
                      );
                    }}
                  />
                  <div className="mb-3">
                    <div className="flex gap-2">
                      <label className="mb-2 text-sm font-semibold inline-block">
                        {t("Select country")}
                      </label>
                      <Tooltip
                        title="Exclude OFAC sanctioned countries"
                        placement="top"
                      >
                        <img
                          src={infoIcon}
                          className="h-[25px] w-[25px] cursor-pointer"
                          alt="info"
                        />
                      </Tooltip>
                    </div>
                    <Select
                      options={filteredOptions}
                      placeholder="Select country"
                      onChange={(value: any) => {
                        setFieldTouched("country", true);
                        setFieldValue("country", value?.value);
                      }}
                    />
                    {touched.country && errors.country && (
                      <p className="my-2 text-xs text-start text-red">
                        {errors && (errors.country as any)}
                      </p>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="mb-2 text-sm font-semibold inline-block">
                      {t("Account type")}
                    </label>
                    <Select
                      options={accounts}
                      placeholder="Account type"
                      onChange={(value: any) => {
                        console.log(value);
                        setFieldTouched("accountType", true);
                        setFieldValue("accountType", value?.value);
                      }}
                    />
                    {touched.accountType && errors.accountType && (
                      <p className="my-2 text-xs text-start text-red">
                        {errors && (errors.accountType as any)}
                      </p>
                    )}
                  </div>
                  {/* <Input
                    className="mb-3"
                    label={t("Address Line 1 (Optional)")}
                    containerClass="w-full"
                    placeholder={t("Address line 1")}
                    name="addressLine1"
                    error={errors.addressLine1}
                    touched={touched.addressLine1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="solid"
                  />
                  <Input
                    label={t("Address Line 2 (Optional)")}
                    containerClass="w-full"
                    className="mb-3"
                    placeholder={t("Address line 2")}
                    name="addressLine1"
                    error={errors.addressLine2}
                    touched={touched.addressLine2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="solid"
                  />
                  <Input
                    label={t("BTC/USSD Address (Optional)")}
                    containerClass="w-full"
                    className="mb-3"
                    placeholder={t("BTC/USSD Address")}
                    name="ussdAddress"
                    error={errors.ussdAddress}
                    touched={touched.ussdAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="solid"
                  /> */}
                  <div className="flex gap-4 mb-3">
                    <Input
                      labelClassName="mt-3 text-base font-medium inline-block"
                      label={t("Password")}
                      containerClass="w-full"
                      placeholder={t("Password")}
                      name="password"
                      type="password"
                      error={errors.password}
                      touched={touched.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="solid"
                    />
                    <Input
                      labelClassName="mt-3 text-base font-medium inline-block"
                      label={t("Confirm Password")}
                      containerClass="w-full"
                      placeholder={t("Confirm Password")}
                      name="confirmPassword"
                      type="password"
                      error={errors.confirmPassword}
                      touched={touched.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="solid"
                    />
                  </div>
                </div>

                <Button
                  className="ml-0 block  w-full bg-blue mt-4 mb-3"
                  loading={isLoading}
                  type="submit"
                >
                  {t("Signup")}
                </Button>
                <p className="text-center">
                  {t("Already have an account?")}
                  <span
                    className="underline text-blue cursor-pointer ml-1"
                    onClick={() => navigate("/signin")}
                  >
                    {t("Please Login")}
                  </span>
                </p>
              </form>
            );
          }}
        </Formik>
      </AuthLayout>
      <Modal open={showOtp} onClose={() => setShowOtp(false)}>
        <form className="p-5">
          <h1 className="text-md font-semibold mb-5">Verification Code</h1>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            inputStyle={{
              height: "60px",
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              width: "40px",
              border: "1px solid grey",
            }}
            renderInput={(props) => <input {...props} />}
            renderSeparator={<span>-</span>}
          />
          {isShowError && <span className="text-red ">Invalid OTP</span>}
          <Button
            loading={otpLoading}
            type="button"
            onClick={handleOtp}
            className="mt-5"
          >
            Submit
          </Button>
        </form>
      </Modal>
      <div id="recaptcha_container"></div>
    </>
  );
};
export default Signup;
